import { ThemeVariables } from '@/interfaces/theme';

const variables = {
  headerHeight: 64,
  menuHeight: 53
} as Partial<ThemeVariables>;

export default variables;
